export default __webpack_public_path__ + "static/media/MichaelJudd.bad66e29.jpeg";